
var GoogleAnalytics = {
      googleAnalyticsActive:false,
      googleUA:false,
      anonymize_ip: true,
      allow_cookie_analytics: false,
      scriptAdded: false,

      init: function (allow_cookies) {

        GoogleAnalytics.googleAnalyticsActive   = document.querySelector('meta[name="googleAnalyticsActive"]').content;
        GoogleAnalytics.googleUA                = document.querySelector('meta[name="googleAnalyticsUA"]').content;
        GoogleAnalytics.allow_cookie_analytics  = allow_cookies;
        GoogleAnalytics.anonymize_ip            = true;

        console.log('google analytics init');
        console.log('google analytics active:'+GoogleAnalytics.googleAnalyticsActive);
        console.log('google analytics UA:'+GoogleAnalytics.googleUA);
        console.log('google analytics allow_cookie_analytics:'+GoogleAnalytics.allow_cookie_analytics);
        if (!GoogleAnalytics.scriptAdded && GoogleAnalytics.allow_cookie_analytics=='true'){
          GoogleAnalytics.addScript();
          GoogleAnalytics.postPage();
        }
      },
      addScript: function(){
        if (!GoogleAnalytics.scriptAdded){
            (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
                (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
                m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
            })(window,document,'script','//www.google-analytics.com/analytics.js','ga');
            ga('create', GoogleAnalytics.googleUA, 'auto');
            console.log('google analytics script added');
            GoogleAnalytics.scriptAdded = true;
        }
      },
      postPage: function (){
        console.log('google analytics post Page test');

        if (GoogleAnalytics.allow_cookie_analytics=='true') {
              console.log('google analytics post Page');

              ga('set', 'location', window.location.href);
              ga('send', 'pageview');

        }
      }

};

export default GoogleAnalytics;
